// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ewc5","rootNoMargin":"styles_rootNoMargin__3ZoqS"};